import { roleToVariant, useRoleText } from '@melio/ap-domain';
import { AvatarWithDetails, Group, Text } from '@melio/penny';
import { UserDetails } from '@melio/platform-api';
import { useMelioIntl } from '@melio/platform-i18n';
import React from 'react';

type Props = {
  scheduledDate: Date;
  user: UserDetails;
};

export const PaymentScheduledBySection = ({ scheduledDate, user }: Props) => {
  const { formatMessage, formatDate } = useMelioIntl();
  const { getRoleText } = useRoleText();

  return (
    <Group variant="vertical" spacing="s">
      <Text textStyle="body4SemiUpper" color="neutral.darker">
        {formatMessage('widgets.paymentDetails.scheduledBy.title')}
      </Text>
      <AvatarWithDetails
        avatarProps={{
          name: `${user.firstName ?? ''} ${user.lastName ?? ''}`,
        }}
        description={formatMessage('widgets.paymentDetails.scheduledBy.subtitle', {
          scheduledDate: formatDate(scheduledDate, { dateStyle: 'medium' }),
        })}
        mainLabelProps={{
          label: formatMessage('widgets.paymentDetails.scheduledBy.name', {
            firstName: user.firstName,
            lastName: user.lastName,
          }),
          badgeProps: {
            label: getRoleText(user.role),
            type: roleToVariant(user.role) === 'secondary' ? 'secondary' : 'primary',
            status: 'neutral',
          },
        }}
      />
    </Group>
  );
};
